/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState, useCallback, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { onGetPromotional } from "../../Store/Slices/promotionalSlice";
import { useDispatch, useSelector } from "react-redux";
// import order from "../../Assets/order.png";
// import profile from "../../Assets/profileNew.png";
// import contact from "../../Assets/contact.png";
import { onGetofferMaster } from "../../Store/Slices/offerMasterSlice";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import logout from "../../../src/Assets/logout_new.png";
import {
  ApplyThemeStyles,
  ClientInfo,
  ClientJourneyType,
  getConfigValue,
  GetImageUrl,
  ThemeData,
  trackEvent,
  useGaTrackingConfig,
  usePoints,
} from "../../Components/Utility/Utility";
import { getProductList } from "../../Store/Slices/productSlice";
import { setProduct } from "../../Store/Slices/productDataSlice";
import { encryptURLParam } from "../../Common/Axios/encrypt";
import { onClientConfigurationSubmit } from "../../Store/Slices/clientConfigurationSlice";
import LogoLink from "./LogoLink";
import { PlatformNavLink } from "./PlatformNavigation";
import HeaderCart, { useShowHeaderCart } from "./HeaderCart";

// Dropdown chevron for the "More" and platform navigation triggers
// (Material arrow_forward_ios, turned to point down in CSS).
const HeaderMenuChevron = ({ isOpen }) => (
  <svg
    className={`header-menu-chevron ${isOpen ? "is-open" : ""}`}
    width="16"
    height="16"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M6.23 20.23 8 22l10-10L8 2 6.23 3.77 14.46 12z" />
  </svg>
);

const DesktopHeader = ({
  scroll,
  matchCategory,
  validateLoginTokenData,
  getInitials,
  profileMenu = true,
  showPromotionalStrip = true,
  promotionalStripPlacement = "aboveHeader",
  platformNav = null,
}) => {
  const themeData = ThemeData();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const currentBalance = usePoints();
  const translation = getTranslationData();
  // Category link ids, encrypted once per category list / session key instead of
  // running AES for every link on every header render.
  const decvKey = sessionStorage.getItem("decv");
  const categoryLinkIds = useMemo(() => {
    const ids = {};
    Object.keys(matchCategory).forEach((item1) => {
      const rawId =
        matchCategory?.[item1]?.id ??
        matchCategory?.[item1]?.categoryId ??
        matchCategory?.[item1]?.clientCategoryId ??
        matchCategory?.[item1]?.value ??
        item1;
      ids[item1] = process.env.REACT_APP_IS_E_E === 'false'
        ? rawId
        : encryptURLParam(String(rawId));
    });
    return ids;
  }, [matchCategory, decvKey]);
  const dropdownRef = useRef(null);
  const [firstPageLoaded, setFirstPageLoaded] = useState(false);
  const modal = useRef(null);
  const isLogin = sessionStorage.getItem("login");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const promotionalList = useSelector((state) => state.promotionalReducer);
  const [promotinalData, setPromotionalData] = useState();
  const [isSearching, setIsSearching] = useState(false);
  const [visibleCount, setVisibleCount] = useState(
    Object.keys(matchCategory)?.length
  );
  const clientinfo = ClientInfo();
  const clientJourneyType = ClientJourneyType();
  const navRef = useRef(null);
  const [isMoreOpen, setIsMoreOpen] = useState(false);
  const [isPlatformNavOpen, setIsPlatformNavOpen] = useState(false);
  const useGaTrackingConfigData = useGaTrackingConfig();
  useEffect(() => {
    const updateVisibleCount = () => {
      if (!navRef.current) return;
      const containerWidth = navRef.current.offsetWidth;
      let totalWidth = 0;
      let count = 0;

      const testSpan = document.createElement("span");
      testSpan.style.visibility = "hidden";
      testSpan.style.position = "absolute";
      testSpan.style.whiteSpace = "nowrap";
      testSpan.className = "nav-link px-2";
      document.body.appendChild(testSpan);

      // Reserve room for the platform navigation trigger so categories move into "More".
      if (platformNav) {
        testSpan.innerText = platformNav.title || "";
        totalWidth += testSpan.offsetWidth + 52; // padding + margin + chevron
      }

      Object.keys(matchCategory).forEach((cat) => {
        testSpan.innerText = cat;
        totalWidth += testSpan.offsetWidth + 32; // padding + margin
        if (totalWidth < containerWidth - 100) {
          count++;
        }
      });

      document.body.removeChild(testSpan);
      setVisibleCount(count);
    };

    updateVisibleCount();

    // Re-measure once web fonts finish loading, since text widths can change
    // and this effect no longer re-runs on every parent render.
    let isActive = true;
    document.fonts?.ready?.then(() => {
      if (isActive) updateVisibleCount();
    });

    const observer = new ResizeObserver(updateVisibleCount);
    if (navRef.current) observer.observe(navRef.current);

    return () => {
      isActive = false;
      observer.disconnect();
    };
  }, [matchCategory, platformNav]);

  const firstName = validateLoginTokenData?.memberProfile?.firstName ?? "";
  const lastName = validateLoginTokenData?.memberProfile?.lastName ?? "";
  const [placeholder] = useState(translation?.searchForGiftcard);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const loginAuthData = useSelector((state) => state.loginAuthReducer);
  const [isModal, setIsModal] = useState(false);

  useEffect(() => {
    if (loginAuthData?.data?.length) {
      dispatch(onClientConfigurationSubmit());
      dispatch(onGetPromotional());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginAuthData?.data?.length]);
  // const loginDetails = useSelector((state) => state.loginReducer);
  const handleLogout = (e) => {
    navigate("/logout");
  };
  const handleClick = (item) => {
    sessionStorage.setItem("ga4_item_list_name", "search results");
    sessionStorage.setItem("ga4_seletedProductIndex", 1);
    const currentPath = String(location?.pathname || "").toLowerCase();
    const currentPageType = currentPath.includes("/card")
      ? "checkout_page"
      : currentPath.includes("/productlist")
        ? "listing_page"
        : currentPath.includes("/giftcard")
          ? "product_page"
          : "home_page";
    dispatch(setProduct(item));
    // Conditionally encrypt the productId parameter based on environment setting
    const productId = item?.id.toString();
    const finalProductId = process.env.REACT_APP_IS_E_E === 'false'
      ? productId
      : encryptURLParam(productId);
    const destinationPath = `/giftcard?productId=${finalProductId}`;
    const destinationUrl = new URL(destinationPath, window.location.origin).href;
    trackEvent("search_product", {
      search_term: item?.name,
      page_type: currentPageType,
      client_code: useGaTrackingConfigData.trackingContext.client_code,
      platform_code: useGaTrackingConfigData.trackingContext.platform_code,
      // found_count: "",
      search_url: `${destinationUrl}`,
    });
    navigate(`/giftcard?productId=${finalProductId}`, { state: { item } });
    setSearchTerm("");
    setFilteredResults([]);
    setIsSearching(false);
    setIsSearchActive(false);
  };

  useEffect(() => {
    if (Array.isArray(promotionalList?.GetPromotional)) {
      const today = new Date().setHours(0, 0, 0, 0);

      const filteredData = promotionalList?.GetPromotional?.filter((item) => {
        const endDate = new Date(item.endDate).setHours(0, 0, 0, 0);
        return item.enabled === true && endDate > today;
      });

      setPromotionalData(filteredData);
    }
  }, [promotionalList?.GetPromotional]);
  const [showPromotional, setShowPromotional] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredResults, setFilteredResults] = useState([]);
  const [searchPageNumber, setSearchPageNumber] = useState(0);
  const [hasMoreSearchResults, setHasMoreSearchResults] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const searchLoaderRef = useRef(null);
  const [keepTyping, setKeepTyping] = useState(false);

  const handleChangeOptimized = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setIsSearchActive(true);

    if (value.trim() === "") {
      setFilteredResults([]);
      setSearchPageNumber(0);
      setHasMoreSearchResults(true);
      setFirstPageLoaded(false);
      setKeepTyping(false);
      setIsSearching(false);
      setIsSearchActive(false)
      return;
    }

    if (value.trim().length < 3) {
      setFilteredResults([]);
      setSearchPageNumber(0);
      setHasMoreSearchResults(true);
      setFirstPageLoaded(false);
      setKeepTyping(true);     // show keep typing
      setIsSearching(false);   // hide "no record"
      return;
    }
    setKeepTyping(false);
    setIsSearching(false);
    setIsLoadingMore(true);

    // reset pagination
    setFilteredResults([]);
    setSearchPageNumber(0);
    setHasMoreSearchResults(true);
    setFirstPageLoaded(false);

    const payload = {
      search: value,
      pageNumber: 1,
      pageSize: 10,
    };

    dispatch(getProductList(payload))
      .then((response) => {
        const data = response?.payload?.response?.products || [];
        const totalCount = response?.payload?.response?.totalCount || 0;

        setFilteredResults(data);
        setHasMoreSearchResults(data.length < totalCount);
        setSearchPageNumber(1);        // last loaded page
        setFirstPageLoaded(true);

        // 3️⃣ ≥3 chars but no results
        if (data.length === 0) {
          setIsSearching(true);        // show "No record found"
        }
      })
      .finally(() => {
        setIsLoadingMore(false);
      });
  };

  // Load more search results
  const loadMoreSearchResults = useCallback(() => {
    if (
      isLoadingMore ||
      !hasMoreSearchResults ||
      !firstPageLoaded ||
      searchTerm.trim().length < 3
    ) {
      return;
    }

    setIsLoadingMore(true);
    const nextPage = searchPageNumber + 1;

    const payload = {
      search: searchTerm,
      pageNumber: nextPage,
      pageSize: 10,
    };

    dispatch(getProductList(payload))
      .then((response) => {
        const newData = response?.payload?.response?.products || [];
        const totalCount = response?.payload?.response?.totalCount || 0;

        setFilteredResults((prev) => {
          const updated = [...prev, ...newData];
          setHasMoreSearchResults(updated.length < totalCount);
          return updated;
        });

        setSearchPageNumber(nextPage);
      })
      .finally(() => {
        setIsLoadingMore(false);
      });
  }, [
    searchTerm,
    searchPageNumber,
    isLoadingMore,
    hasMoreSearchResults,
    firstPageLoaded,
    dispatch,
  ]);

  // IntersectionObserver for search dropdown infinite scroll
  useEffect(() => {
    if (
      !searchLoaderRef.current ||
      !isSearchActive ||
      !hasMoreSearchResults ||
      !firstPageLoaded
    ) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isLoadingMore) {
          loadMoreSearchResults();
        }
      },
      {
        root: null,
        rootMargin: "20px",
        threshold: 0,
      }
    );

    observer.observe(searchLoaderRef.current);

    return () => observer.disconnect();
  }, [
    filteredResults.length,
    isSearchActive,
    hasMoreSearchResults,
    firstPageLoaded,
    isLoadingMore,
    loadMoreSearchResults,
  ]);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      // Keep the same empty array so scroll events don't force a re-render.
      setFilteredResults((prev) => (Array.isArray(prev) && prev.length === 0 ? prev : []));
      setSearchTerm("");
      setIsSearchActive(false);
    }

    if (modal.current && !modal.current.contains(event.target)) {
      setIsModal(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("scroll", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("scroll", handleClickOutside);
    };
  }, []);

  const handleImageClick = (item) => {
    const categoryId = String(
      matchCategory?.[item]?.id ??
      matchCategory?.[item]?.categoryId ??
      matchCategory?.[item]?.clientCategoryId ??
      matchCategory?.[item]?.value ??
      item,
    );
    // Conditionally encrypt the categoryId parameter based on environment setting
    const finalCategoryId = process.env.REACT_APP_IS_E_E === 'false'
      ? categoryId
      : encryptURLParam(categoryId);
    setIsMoreOpen(false);
    navigate(`/productlist?categoryId=${finalCategoryId}`, {
      state: { item },
    });
  };

  useEffect(() => {
    if (searchTerm) {
      document.body.classList.add("no-scroll");
      setHasMoreSearchResults(true);

    } else {
      document.body.classList.remove("no-scroll");
    }
    if (searchTerm.trim().length < 3) return;
    setFilteredResults([]);
    setSearchPageNumber(0);
    setHasMoreSearchResults(true);
    setFirstPageLoaded(false)

    // manually load first page
    loadMoreSearchResults();
  }, [searchTerm]);

  const signInUrl = useSelector((state) => state.cardDataSliceReducer?.SignInUrl);
  useEffect(() => {
    if (location.pathname.endsWith("/otp")) {
      setShowPromotional(false);
    }
  }, [location.pathname]);

  const handleLogin = () => {
    const pathName = window.location.pathname;
    const search = window.location.search;
    localStorage.setItem("ProductListPage", pathName + search);
    localStorage.setItem("ProductListPage_back", pathName + search);
  };
  const clientConfigurations = clientinfo?.clientData?.clientConfigurations;
  const isLoginDisabled = getConfigValue(clientConfigurations, "isLogin");
  const showHeaderCart = useShowHeaderCart();
  const isEarn = clientConfigurations?.find((item) => item.configKey?.toLowerCase() === "isearn")?.configValue;
  const isBurn = clientConfigurations?.find((item) => item.configKey?.toLowerCase() === "isburn")?.configValue;

  useEffect(() => {
    ApplyThemeStyles(themeData);
  }, [themeData]);

  // Platform links (Shop, Memberships ...) as a dropdown placed before or after the categories.
  const platformNavMenu = platformNav && (
    <li
      className="platform-nav-menu"
      onMouseEnter={() => setIsPlatformNavOpen(true)}
      onMouseLeave={() => setIsPlatformNavOpen(false)}
    >
      <button
        type="button"
        className="linkprop header-menu-trigger platform-nav-trigger"
        aria-haspopup="true"
        aria-expanded={isPlatformNavOpen}
        onClick={() => setIsPlatformNavOpen((prev) => !prev)}
      >
        {platformNav.title}
        <HeaderMenuChevron isOpen={isPlatformNavOpen} />
      </button>
      {isPlatformNavOpen && (
        <ul className="header-menu-dropdown platform-nav-dropdown">
          {platformNav.items.map((item) => (
            <li key={item.key}>
              <PlatformNavLink
                item={item}
                comingSoonText={platformNav.comingSoonText}
                className="header-menu-item"
                onSelect={() => setIsPlatformNavOpen(false)}
              />
            </li>
          ))}
        </ul>
      )}
    </li>
  );

  return (
    <>
      {isSearchActive && <div className="screen-blur" />}
      <header className="header forTab-hide mobile-hide">
        <div
          className={`fixheader top-hh ${scroll && "sticky"}`}
          style={{ display: "flex", flexDirection: "column" }}
        >
          {showPromotionalStrip && showPromotional &&
            Array?.isArray(promotinalData) &&
            promotinalData?.map((item) => (
              <div
                className="top-hh"
                key={item.id}
                style={{ order: promotionalStripPlacement === "belowHeader" ? 1 : -1 }}
              >
                <div className="top-menu oaoa1">
                  <div className="d-flex ml-10 ">
                    <p className="promo">&nbsp;{item?.titleText}</p>
                    {(item?.link && item?.linkText) && (
                      <p className="mar-earn">
                        <Link to={item?.link} className="exp hoverPromo">
                          <span
                            dangerouslySetInnerHTML={{ __html: item?.linkText }}
                          />{" "}
                          <i className="fa-solid fa-arrow-right"></i>
                        </Link>
                      </p>
                    )}
                  </div>
                  <button
                    className="close-Btn "
                    onClick={() => setShowPromotional(false)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="21"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="var(--explore-earn-text-color)"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <line x1="18" y1="6" x2="6" y2="18" />
                      <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                  </button>
                </div>
              </div>
            ))}
          <div className="main-header fitted ">
            <div className="container">
              <div className="row align-items-lg-center">
                <div className="col-xl-3 col-lg-4 col-7 order-0 order-lg-0"></div>
                <div className="col-xl-3 col-lg-2 col-5 order-1 order-lg-2"></div>
                <div className="col-xl-6 col-lg-6 col-12 order-2 order-lg-1"></div>
              </div>
            </div>
          </div>
          <div className="botheader">
            <div className="container">
              <div className="d-flex  top-menu desktop_top_menu_section">
                <div className=" d-xl-none d-none p-3">
                  <div className="mobilemenulogo text-center">
                    <Link to="/">{/* <img src={Logo} alt="img" /> */}</Link>
                  </div>
                  <div className="menuclosebtn">
                    <Link to="#">
                      <i className="las la-times"></i>
                    </Link>
                  </div>
                </div>
                <div className="logo_section">
                  <div className="button"></div>
                  <div className="logo">
                    <LogoLink
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "7px",
                      }}
                    >
                      <img
                        src={GetImageUrl(clientinfo.logoUrl)}
                        alt="logo"
                        style={{ width: "104.48px", height: "31.87px" }}
                      />
                      {clientinfo?.giftLogo && (
                        <>
                          <div className="vertical-line"></div>
                          <img
                            src={GetImageUrl(clientinfo?.giftLogo)}
                            alt="Gift logo"
                            style={{ width: "54.18px", height: "31.09px" }}
                          />
                        </>
                      )}
                    </LogoLink>
                  </div>
                </div>
                <div
                  className={`thecate ${matchCategory?.length > 3 ? "ms-5" : "ml-10"
                    } ${isLogin ? "wid50" : "wid55"}`}
                  ref={navRef}
                >
                  <nav id="cssmenu" className="">
                    <ul>
                      {platformNav?.placement === "above" && platformNavMenu}
                      {Object.keys(matchCategory)

                        .slice(0, visibleCount)
                        .map((item1, index) => (
                          <li key={index} onClick={() => sessionStorage.removeItem("ga4_item_list_name")}>

                            <Link
                              to={`/productlist?categoryId=${categoryLinkIds[item1]}`}

                              state={{ item1 }}
                            >
                              {item1}
                            </Link>
                          </li>
                        ))}
                      {visibleCount < Object.keys(matchCategory)?.length && (
                        <li className="more-button"
                          onMouseEnter={() => setIsMoreOpen(true)}
                          onMouseLeave={() => setIsMoreOpen(false)}
                        >
                          <span className="linkprop header-menu-trigger">
                            {translation?.more}
                            <HeaderMenuChevron isOpen={isMoreOpen} />
                          </span>
                          {isMoreOpen &&
                            <ul className="submenulist header-menu-dropdown">
                              {Object.keys(matchCategory)
                                .slice(visibleCount)
                                .map((item1, index) => (
                                  <li
                                    key={index + visibleCount}
                                    className={`menu-item ${selectedProduct === item1 ? "hovered" : ""
                                      }`}
                                    onMouseEnter={() => setSelectedProduct(item1)}
                                    onMouseLeave={() => setSelectedProduct(null)}
                                  >
                                    <div
                                      className="a header-menu-item"
                                      onClick={() => handleImageClick(item1)}
                                    >
                                      {item1}
                                    </div>
                                  </li>
                                ))}
                            </ul>
                          }
                        </li>
                      )}
                      {platformNav?.placement === "below" && platformNavMenu}
                    </ul>
                  </nav>
                </div>
                <div className="login-btn1">
                  <div className="thesearch " ref={dropdownRef}>
                    <div className="searchboxmaindiv">
                      <div className="searchbox">
                        <a id="btnsearch">
                          <i className="las la-search"></i>
                        </a>
                        <input
                          name="ctl00$txtsearch"
                          type="text"
                          id="txtsearch"
                          className="autosuggest"
                          autoComplete="off"
                          placeholder={placeholder}
                          value={searchTerm}
                          onChange={handleChangeOptimized}
                        />
                      </div>
                      {searchTerm && (
                        <ul
                          className="dropdown1"
                        >

                          {filteredResults?.length > 0
                            ? filteredResults.map((item, index) => (
                              <li
                                onClick={() => handleClick(item)}
                                key={`${item.id}-${index}`}
                                className="dropdown-item d-flex align-item-center"
                              >
                                <i
                                  className="las la-search mx-2"
                                  style={{ fontSize: "1.5em" }}
                                ></i>{" "}
                                {item.name}
                              </li>
                            ))
                            : keepTyping ? (
                              <li className="dropdown-item text-center py-2">
                                {translation?.keepTyping}
                              </li>
                            ) : isSearching && (
                              <li className="dropdown-item text-center py-2">
                                {translation?.NoRecordsFound}
                              </li>
                            )
                          }

                          {/* Loader element for infinite scroll */}
                          {hasMoreSearchResults &&
                            // filteredResults.length > 0 && 
                            <li
                              ref={searchLoaderRef}
                              className="dropdown-item text-center py-0"
                              style={{ minHeight: "10px" }}
                            >
                              {/* {isLoadingMore ? "Loading more..." : ""} */}
                              {isLoadingMore ? (
                                <span>Loading more...</span>
                              ) :
                                isSearching ? (
                                  <span style={{ opacity: 0 }}>
                                    Load trigger
                                  </span>
                                )
                                  : null}
                            </li>

                            // )
                          }
                        </ul>
                      )}
                    </div>
                  </div>
                  <div className="right_menubox d-flex">
                    <div id="desktop-card-balance-root" />
                    {clientJourneyType && isLogin && isEarn !== "2" && isBurn !== "2" ? (
                      <div className="point-div ">
                        <div id="ctl00_pointdesk" className="prodiscounter44">
                          <i className="fa-solid fa-star buy mar"></i>{" "}
                          {currentBalance?.toLocaleString()}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {/* With the cart on, the header has search, cart and profile only. */}
                    {!showHeaderCart && profileMenu && <>
                      {profileMenu.find((item) => item.label === "Contact Us" && item.visible)?.visible && (
                        <div className="desktop-headphone-icon">
                          <ul>
                            <li className="headphone-icon">
                              <a href="/contact-us">
                                <i className="las la-headphones home-tab"></i>

                              </a>
                            </li>
                          </ul>
                        </div>
                      )}
                    </>}
                    {showHeaderCart && (
                      <div className="desktop-cart-icon">
                        <ul>
                          <HeaderCart />
                        </ul>
                      </div>
                    )}

                    <div className="theprofile">
                      <div className={`top-right clearfix`}>
                        {isLogin ? (
                          <ul className="">
                            <li className="meiconbtn">
                              <span
                                onClick={() => setIsModal(true)}
                                className="profile-p"
                              >
                                <div className="profile ">
                                  <div className="profile-initials">
                                    {getInitials(firstName, lastName)}
                                  </div>
                                </div>
                              </span>
                              {isModal ? (
                                <div
                                  className="logindropbox logindrop-ch"
                                  ref={modal}
                                >
                                  <div className="logindrop2">
                                    <ul className="pb-1">
                                      {profileMenu?.map((item, index) => (
                                        !!item.visible &&
                                        <li className="profile_li" key={index}>
                                          <img
                                            className="icon-sz"
                                            src={GetImageUrl(item.iconurl)}
                                            alt={item.label}
                                          />
                                          <Link
                                            to={item.link}
                                            onClick={() => setIsModal(false)}
                                            className="link-border"
                                          >
                                            {item.label}
                                          </Link>
                                        </li>
                                      ))}

                                      {/*    <li className="profile_li">
                                      <img
                                        className="icon-sz"
                                        src={profile}
                                        alt="profie"
                                      />
                                      <Link
                                        onClick={() => setIsModal(false)}
                                        to="/myprofile"
                                        className="link-border"
                                      >
                                        {translation?.myProfile}
                                      </Link>
                                    </li>
                                    {/*    <li className="profile_li">
                                      <img
                                        className="icon-sz"
                                        src={order}
                                        alt="order"
                                      />
                                      <Link
                                        to="/orders"
                                        onClick={() => setIsModal(false)}
                                        className="link-border"
                                      >
                                        {translation?.orders}
                                      </Link>
                                    </li>
                                    <li className="profile_li">
                                      <img
                                        className="icon-sz"
                                        src={contact}
                                        alt="contact"
                                      />
                                      <Link
                                        onClick={() => setIsModal(false)}
                                        to="/contact-us"
                                      >
                                        {translation?.contactUs}
                                      </Link>
                                    </li>

                                    <li className="profile_li">
                                      <img
                                        className="icon-sz"
                                        src={logout}
                                        alt="contact"
                                      />

                                      <span
                                        onClick={handleLogout}
                                        className="logout-span"
                                      >
                                        Logout
                                      </span>
                                    </li> */}

                                    </ul>
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}
                            </li>
                          </ul>
                        ) : (isLoginDisabled?.isLoginDisabled !== 1 &&
                          <ul className="head-login">
                            <li id="ctl00_lnklogin">
                              <Link
                                to={signInUrl}
                                onClick={() => handleLogin()}
                                className="login_btn"
                              >
                                {translation?.loginLabel}
                              </Link>
                            </li>
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default DesktopHeader;
